import React, {useState} from "react";
import {useParams} from "react-router-dom";

import {fetchEventSurvey} from "../../../api/SurveyAPI.js";
import SurveyEditor from "../../../components/adhara/admin/survey/SurveyEditor.js";
import SurveyResponses from "../../../components/adhara/admin/survey/SurveyResponses.js";
import APIFetcher from "../../../components/loading/APIFetcher.js";
import AdminEventLayout from "../../../layouts/AdminEventLayout.js";

const ManageCourseSurvey = () => {
    const { eventId } = useParams();

    const [survey, setSurvey] = useState({});

    const fetchItems = () => fetchEventSurvey(eventId).then(setSurvey)

    return (
        <AdminEventLayout eventId={eventId}>
            <APIFetcher fetchItems={fetchItems}>
                <SurveyResponses survey={survey}/>
                <SurveyEditor
                    sections={survey.sections} surveyId={survey.id}
                    onChange={(edit) => setSurvey(prev => ({...prev, sections: edit(prev.sections)}))}
                />
            </APIFetcher>
        </AdminEventLayout>
    )
}


export default ManageCourseSurvey;